export function chunk<Item>(array: Item[], size: number): Item[][] {
  const chunkedArray = []
  if (size < 1) {
    chunkedArray.push(array)
    return chunkedArray
  }
  for (let i = 0; i < array.length; i += size) {
    chunkedArray.push(array.slice(i, i + size))
  }
  return chunkedArray
}

/**
 * Shorthand for Object.values()
 */
export function values<T>(object: { [s: string | number]: T } | ArrayLike<T>): T[] {
  return Object.values(object)
}

/**
 * Shorthand for typed Object.keys()
 */
export function keys<K extends string | number | symbol>(object: Record<K, unknown>): K[] {
  return Object.keys(object) as K[]
}

export function omit<K extends object, Omitted extends Extract<keyof K, string>>(
  obj: K,
  ...omitting: Omitted[]
): Omit<K, Omitted> {
  const newObj: Partial<K> = {}
  for (const key in obj) {
    if (omitting.includes(key as Omitted)) {
      continue
    }
    newObj[key] = obj[key]
  }
  return newObj as Omit<K, Omitted>
}

export function pick<K extends object, Picked extends keyof K>(obj: K, ...picking: Picked[]): Pick<K, Picked> {
  const newObj: Partial<K> = {}
  for (const key in obj) {
    if (picking.includes(key as unknown as Picked)) {
      newObj[key] = obj[key]
    }
  }
  return newObj as Pick<K, Picked>
}

export function normaliseArray<T>(v: T | T[]): T[] {
  return Array.isArray(v) ? v : [v]
}
export type Keyable = string | number | symbol

/**
 * Invert key and values of an object
 */
export function invert<K extends Keyable, V extends Keyable>(data: Record<K, V>): Record<V, K> {
  return Object.fromEntries(Object.entries(data).map(([key, value]) => [value, key]))
}
export function invertMap<K extends Keyable, V extends Keyable>(data: Map<K, V>): Map<V, K> {
  const map = new Map<V, K>()
  for (const [v, k] of data) {
    map.set(k, v)
  }
  return map
}
